import { computed, reactive } from 'vue'
import { camelizeKeys } from 'humps'
import { useLoader } from './useLoader'
import { useError } from './useError'
import axios from '@/axios'

const topState = reactive({
  denominationsTop: [],
})

export const useDenominations = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()

  /**
   * 会派一覧を取得する
   */
  const getDenominations = async () => {
    try {
      toggleShowLoader(true)
      let res = await axios.get('/denominations')
      res = camelizeKeys(res)
      topState.denominationsTop = Array.from(res.data.denominations)
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    denominationsTop: computed(() => topState.denominationsTop),
    getDenominations
  }
}
